// extracted by mini-css-extract-plugin
export default {"modalContainer":"ErrorModal_modalContainer__H18-T","modal":"ErrorModal_modal__AeIyh","titleContainer":"ErrorModal_titleContainer__sMWGb"};